import { Link } from 'react-router'
import { FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa6'
import { RiArrowRightLine, RiMapPin2Line, RiMailLine } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'
import logoSrc from '@/assets/logo/logo.png'

const quickLinks = [
  { to: ROUTES.HOME, label: 'Home' },
  { to: ROUTES.ABOUT, label: 'About Simone' },
  { to: ROUTES.SERVICES, label: 'Services' },
  { to: ROUTES.ENQUIRY, label: 'Free Call Enquiry' },
]

const serviceLinks = [
  'Antenatal Empowerment',
  'Birth Healing Debrief',
  'Postpartum Home Visits',
  'Birth Journey Experience',
]

const socialLinks = [
  {
    icon: <FaInstagram size={17} />,
    href: 'https://www.instagram.com/h.e.rbirthkeeper/',
    label: 'Instagram',
  },
  {
    icon: <FaFacebook size={17} />,
    href: 'https://www.facebook.com/share/1F6yUyLLnY/',
    label: 'Facebook',
  },
  {
    icon: <FaTiktok size={17} />,
    href: 'https://www.tiktok.com/@h.e.r.birth.keeper',
    label: 'TikTok',
  },
]

export const Footer = () => (
  <footer className="bg-crimson-800 font-body">
    {/* Main grid */}
    <div className="max-w-[1200px] mx-auto px-6 pt-[clamp(48px,8vw,72px)] pb-12 grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-12">
      {/* Brand */}
      <div>
        <img src={logoSrc} alt="H.E.R Birth Keeper" className="h-20 w-auto mb-4" />
        <p className="font-display text-[15px] italic text-base-300 leading-[1.7] mb-5 max-w-[240px]">
          Where Healing Begins, Empowerment Grows, and Restoration Follows.
        </p>
        <p className="text-xs text-base-500 mb-5 leading-relaxed flex items-center gap-1.5">
          <RiMapPin2Line size={12} className="text-gold-500 shrink-0" />
          Essex &middot; North Kent &middot; East London
        </p>
        <div className="flex gap-2.5">
          {socialLinks.map((s) => (
            <a
              key={s.label}
              href={s.href}
              aria-label={s.label}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-btn"
            >
              {s.icon}
            </a>
          ))}
        </div>
      </div>

      {/* Navigate */}
      <div>
        <h4 className="font-display text-[17px] font-semibold text-white mb-4">Navigate</h4>
        {quickLinks.map((l) => (
          <Link key={l.label} to={l.to} className="footer-link">
            {l.label}
          </Link>
        ))}
      </div>

      {/* Services */}
      <div>
        <h4 className="font-display text-[17px] font-semibold text-white mb-4">Services</h4>
        {serviceLinks.map((s) => (
          <Link key={s} to={ROUTES.SERVICES} className="footer-link">
            {s}
          </Link>
        ))}
      </div>

      {/* Get in Touch */}
      <div>
        <h4 className="font-display text-[17px] font-semibold text-white mb-4">Get in Touch</h4>
        <p className="text-[13px] text-base-500 mb-5 leading-relaxed">
          Ready to begin your journey? Book a free support call with Simone today.
        </p>
        <a
          href="mailto:info@herbirthkeeper.co.uk"
          className="inline-flex items-center gap-1.5 text-base-300 text-[13px] hover:text-gold-300 transition-colors duration-200 mb-4"
        >
          <RiMailLine size={14} className="text-gold-500 shrink-0" />
          info@herbirthkeeper.co.uk
        </a>
        <Link
          to={ROUTES.ENQUIRY}
          className="flex items-center gap-2 text-gold-400 text-[13px] font-semibold hover:text-gold-300 transition-colors duration-200"
        >
          Unlock your free call
          <RiArrowRightLine size={14} />
        </Link>
      </div>
    </div>

    {/* Gold divider */}
    <div className="h-px bg-gradient-to-r from-transparent via-gold-500 to-transparent opacity-25" />

    {/* Bottom bar */}
    <div className="max-w-[1200px] mx-auto px-6 py-4 flex flex-wrap items-center justify-between gap-2.5">
      <p className="text-xs text-base-500">
        &copy; {new Date().getFullYear()} H.E.R Birth Keeper &middot; All rights reserved.
      </p>
      <p className="text-xs text-base-500">
        Site designed by{' '}
        <a
          href="https://www.zhuwafrica.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-base-300 hover:text-gold-300 transition-colors duration-200"
        >
          Zhuwa Africa Ltd
        </a>
      </p>
    </div>
  </footer>
)
